import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Icone from './Icones';
import Logo from './Logo';

const BULLETS: [string, string][] = [
  ['chave', 'Ordens de serviço com status e tempos automáticos'],
  ['qr', 'Ativos com QR Code e histórico completo'],
  ['grafico', 'Dashboard de indicadores em tempo real'],
];

export default function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="auth-wrap">
      <aside className="auth-side">
        <span className="orb orb1" /><span className="orb orb2" />
        <div className="auth-glimpse surge" aria-hidden="true">
          <div className="auth-glimpse-head"><span>OS-000128</span><b>Em execução</b></div>
          <div className="auth-glimpse-row done"><i /> Checklist concluído</div>
          <div className="auth-glimpse-row done"><i /> Assinatura do cliente</div>
          <div className="auth-glimpse-row on"><i /> Relatório em PDF</div>
        </div>
        <div className="auth-side-content surge">
          <Link to="/" style={{ display: 'inline-block' }}><Logo variant="light" size={42} /></Link>
          <h2>Gestão operacional e automação, sem complicação.</h2>
          <ul className="auth-bullets">
            {BULLETS.map(([ic, t]) => (
              <li key={t}><Icone nome={ic} size={20} /> {t}</li>
            ))}
          </ul>
          <div className="auth-proof">
            <div><b>2.000+</b><span>OS/mês</span></div>
            <div><b>10 mil+</b><span>transações</span></div>
            <div><b>300+</b><span>ativos</span></div>
          </div>
          <p className="auth-foot">CNPJ 48.634.165/0001-41</p>
        </div>
      </aside>

      <main className="auth-form-area">
        <div className="auth-mobile-hero">
          <Link to="/" style={{ display: 'inline-block' }}><Logo variant="light" size={38} /></Link>
          <p>Gestão operacional e automação, sem complicação.</p>
        </div>
        <div className="auth-card surge">
          {children}
        </div>
      </main>
    </div>
  );
}
